import { ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE } from 'actions/asq';

const defaultState = {};

export default function asqSurveyResultsParentEmailSendout(state = defaultState, action) {
  switch (action.type) {
  case ASQ_SURVEY_RESULTS_PARENT_EMAIL_SENDOUT_RECEIVE:
    return action.payload;
  default:
    return state;
  }
}
